import script from "./JournalMoment.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalMoment.vue?vue&type=script&setup=true&lang=js"

import "./JournalMoment.vue?vue&type=style&index=0&id=57ba6a98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ba6a98"]])

export default __exports__